module.exports = __webpack_public_path__ + "img/Swaziland.fd7d0ed9.png";